/**
 * @param amount The amount to convert (can be float or integer)
 * @description This function will convert a number value to the lowest denomination
 * If the input is a float (e.g. 10.99), it returns 1099
 * If the input is an integer (e.g. 10), it returns 1000
 * * The payment amount is in minor units to charge the customer's card.
 * Use the correct minor units amount for the merchant account currency.
 * Example: 10.99 would be converted to 1099
 * https://developer.paysafe.com/en/api-docs/paysafe-js/tokenize/
 */
export const convertToLowestDenomination = (amount: number): number => {
    const amountString = amount.toString()
    if (!amountString.includes('.')) {
        return amount * 100
    }

    const [whole, decimal] = amountString.split('.')
    const paddedDecimal = decimal.padEnd(2, '0')
    return parseInt(whole + paddedDecimal)
}
